module.exports = __webpack_public_path__ + "img/icon_black_lock.873e1bee.svg";